import React, {Component} from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {Grid, Button, Popup, Header, Icon, Advertisement} from "semantic-ui-react";
import CircuitName from "./CircuitName";
import UserName from "./Card";
import AdSense from 'react-adsense';
import {BasicAd} from "./BasicAd";

class ShowOff extends Component {
    captureOutboundLink = function(url) {
        if (typeof gtag === "function") {
            gtag("event", "pcbgogo", {"event_category": "3d ads", "event_label": "pcbgogo"});
        }
    }
    render() {
        return(
        <div id="show-off">
        <Grid verticalAlign="middle" middele="'true'" columns={12} stackable={false}
              style={{minHeight: this.props.show_ads ? 95 : 60, paddingTop: 2, backgroundColor: '#eeeeee', paddingLeft: 15}}>
            {this.props.show_ads &&
                <>
                {this.props.shining_ad && false &&
                    <Grid.Column width={1} key='shiningad' style={{padding: 2}}>

                            <a href="https://www.pcbgogo.com/promo/from_dcaclab" target="_blank" rel="sponsored noopener noreferrer"
                           onClick={()=> {this.captureOutboundLink('https://www.pcbgogo.com/promo/from_dcaclab'); return false;}}>
                                <p className='ad'>
                                    Try 1-2 layer FR-4 PCB Prototyping Free
                                </p>
                            </a>

                        {/*</div>*/}
                    </Grid.Column>
                }
                <Grid.Column verticalAlign="middle" width={4} key='app_links' >
                    <div >
                    <a target="_blank" as='a' href='https://dcaclab.com/pages/classrooms-mangement'>
                        {/*<Icon name='info' />*/}
                        Classrooms
                    </a>
                    <a style={{paddingLeft: 10}}  color='orange'  target="_blank" as='a' href='https://dcaclab.com/pages/assignments-management'>
                        {/*<Icon name='info' />*/}
                        Assignment
                    </a>

                    <a style={{paddingLeft: 10}} icon='youtube' color='red'  target="_blank" as='a' href='https://youtube.com/playlist?list=PLzqxk04syoqIbxD2WYsjI8W4ghoiyKbTW'>
                        Tutorials
                    </a>
                    </div>
                </Grid.Column>
                </>
            }

            {false && this.props.show_ads &&
                <>
                <Grid.Column width={7} key='adsense' textAlign="left" style={{backgroundColor: "transparent"}}>
                    <Advertisement centered unit="leaderboard">
                        <BasicAd slot="1035864869"/>
                    </Advertisement>
                </Grid.Column>
                </>
            }            
            {
             this.props.featured_experiments.map((experiment, index)=>
                index < (this.props.show_ads ? 6 : 6) && <Grid.Column key={index} style={{padding: 0}}>
                    <Popup
                           position={index == 0 ? 'bottom left' : 'bottom center'}
                           hoverable
                           flowing
                           pinned={true}
                           trigger={

                           <Button href={experiment.url} target='_blank' style={{padding: 3}}>
                               <div className="side-crop">
                                    <LazyLoadImage
                                        onError={(event) => event.target.src = ''}
                                        alt={experiment.alt}
                                        style={{maxHeight :55, minHeight: 55}}
                                        src={experiment.thumbnail_url} // use normal <img> attributes as props
                                    />
                               </div>
                            </Button>

                    }>


                    <a href={experiment.url} target='_blank'><h4>{experiment.name}</h4></a>
                    
                    <UserName width={400} color='#00000' creator={experiment.creator}/>

                    </Popup>
                </Grid.Column>
            )
            }
        </Grid>
        </div>
        )
    }
}

export default ShowOff;
